module.exports = __webpack_public_path__ + "static/fm-bg-37bcb57fb0e75973b9e2571b75a50962.jpg";